module["exports"] = [
  "nl",
  "com",
  "net",
  "org"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/nl/internet/domain_suffix.js
 ** module id = 889
 ** module chunks = 0
 **/